import React from "react";
import { useSelector } from "react-redux";
import { SearchingDataProvider } from "../../Context/SearchingDataContext";
import RenderUI from "../render-cpn/render";

export default function RenderModal(props) {
  const { lang } = useSelector((state) => state);
  const { idModal, anotherModal, setModal, setIdModal, popupStyles } = props;
  return (
    <>
      <div
        className="modal fade"
        id={idModal}
        aria-labelledby={idModal}
        style={{
          display: anotherModal ? "none" : "block",
          zIndex: 9999 + (anotherModal ? 10 : 0),
        }}
        // data-backdrop="static"
      >
        <div className="modal-dialog" style={popupStyles}>
          <div className="modal-content custome">
            <div className="modal-header justify-content-end">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                // onClick={() => {
                //   setModal(false);
                //   setIdModal();
                // }}
              >
                &times;
              </button>
            </div>
            <div
              className="modal-body"
              style={{
                maxHeight: "82vh",
                overflowY: "auto",
                overflowX: "unset",
              }}
            >
              <SearchingDataProvider>
                <RenderUI {...props} />
              </SearchingDataProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
